import ReportTab = App.Enums.ReportTab;
import DataType = App.Enums.DataType;
import AreaUnit = App.Enums.AreaUnit;
import ReportParkingType = App.Enums.ReportParkingType;
import PerCalendarUnit = App.Enums.PerCalendarUnit;

export default {
  public: false,
  hideCover: false,
  saveAndShareSidebarOpen: false,
  showMainImage: true,
  unsavedChanges: false,
  id: '',
  digitalShortUrl: '',
  digitalQrCode: '',
  leadCaptureShortUrl: '',
  leadCaptureQrCode: '',
  pdfUrl: null,
  accountId: '',
  agentId: '',
  templateId: '',
  currentTab: 'overview' as ReportTab,
  selectedTab: null,
  bookViewingUrl: '',
  content: {
    streetGroupPropertyId: '',
    reportTitle: 'Property report',
    address: {
      addressLine1: '',
      addressLine2: '',
      fullAddress: '',
      anonymisedFullAddress: '',
      shortAddress: '',
      houseNumber: '',
      street: '',
      locality: '',
      town: '',
      postcode: '',
    },
    location: null,
    market: {
      isEmpty: true,
      display: true,
      localAuthorityCode: null,
      localAuthorityName: null,
      sales: {
        display: true,
        order: 1,
        isEmpty: false,
        salesAveragePricePerSqft: {
          display: true,
          order: 1,
          stats: [],
          isEmpty: true,
        },
        salesAverageTimeOnMarket: {
          display: true,
          order: 2,
          stats: [],
          isEmpty: true,
        },
        salesEstimatedPriceChange: {
          display: true,
          order: 3,
          stats: [],
          isEmpty: true,
        },
        salesVolumeOfSoldProperties: {
          display: true,
          order: 4,
          stats: [],
          isEmpty: true,
        },
      },
      lettings: {
        display: true,
        order: 2,
        isEmpty: false,
        lettingsEstimatedPriceChange: {
          display: true,
          order: 5,
          stats: [],
          isEmpty: true,
        },
        lettingsAverageTimeOnMarket: {
          display: true,
          order: 6,
          stats: [],
          isEmpty: true,
        },
        lettingsVolumeOfLetProperties: {
          display: true,
          order: 7,
          stats: [],
          isEmpty: true,
        },
        lettingsAveragePropertyYield: {
          display: true,
          order: 8,
          stats: [],
          isEmpty: true,
        },
      },
      order: 5,
    },
    overview: {
      display: true,
      plot: null,
      mainImage: null,
      propertyListings: null,
      mainImageSource: null,
      streetView: {
        display: true,
        barcode: '',
        url: '',
        position: null,
        overridden: false,
        order: 1,
      },
      propertyValue: {
        display: true,
        estimatedAnnualRentalYield: 0,
        estimatedRentalValue: 0,
        perCalendarUnit: 'pcm' as PerCalendarUnit,
        estimatedRentalValueLabel: '',
        estimatedValue: 0,
        estimatedValueSource: 'predicted' as DataType,
        estimatedRangeLower: null,
        estimatedRangeLowerSource: 'predicted' as DataType,
        estimatedRangeHigher: null,
        estimatedRangeHigherSource: 'predicted' as DataType,
        estimatedValueLabel: '',
        order: 2,
        showAnnualRentalYield: true,
        showEstimatedRange: true,
        showEstimatedRentalValue: true,
        estimatedRentalValueSource: 'predicted' as DataType,
        showEstimatedValue: true,
        isEmpty: false,
        showConfidenceDisclaimer: true,
      },
      marketHistory: {
        isEmpty: false,
        content: [],
        display: true,
        order: 4,
      },
      build: {
        display: true,
        numberOfBathrooms: null,
        bathroomsPredicted: null,
        numberOfBedrooms: null,
        bedroomsPredicted: null,
        order: 5,
        propertyType: null,
        propertyTypePredicted: null,
        yearBuilt: null,
        yearBuiltPredicted: null,
        yearBuiltLabel: '',
        isEmpty: false,
      },
      propertySize: {
        display: true,
        floorArea: null,
        floorAreaSquareFeet: null,
        floorAreaPredicted: null,
        order: 6,
        plotSize: null,
        plotSizeAcres: null,
        plotSizePredicted: null,
        isEmpty: false,
      },
      plotInformation: {
        display: true,
        uprn: null,
        order: 20,
      },
      description: {
        body: '',
        display: true,
        order: 3,
        title: '',
        isEmpty: false,
      },
      councilTax: {
        display: true,
        estimatedCost: null,
        localAuthority: null,
        order: 7,
        taxBand: null,
        isEmpty: false,
      },
      tenure: {
        display: true,
        order: 8,
        type: 'Unknown',
        tenureTypePredicted: null,
        leaseDetails: {
          endDate: null,
          timeRemainingLabel: '',
          leaseTermLabel: '',
          leaseTermInDays: null,
          leaseTermMonths: null,
          leaseTermYears: null,
          timeRemainingInDays: null,
          timeRemainingMonths: null,
          timeRemainingYears: null,
        },
        isEmpty: false,
      },
      floodRisk: {
        display: true,
        order: 9,
        riversAndSeas: null,
        riversAndSeasPredicted: null,
        surfaceWater: null,
        surfaceWaterPredicted: null,
        isEmpty: false,
      },
      epc: {
        display: true,
        energyEfficiency: null,
        environmentalImpact: null,
        order: 12,
        validUntil: '',
        isEmpty: false,
        content: [],
      },
      listedBuildings: {
        content: [],
        display: true,
        order: 14,
        isEmpty: false,
      },
      planningApplications: {
        content: [],
        display: true,
        order: 13,
        isEmpty: false,
      },
      mobileCoverage: {
        content: [],
        display: true,
        order: 10,
        isEmpty: false,
      },
      broadbandSpeed: {
        content: [],
        display: true,
        order: 11,
        isEmpty: false,
      },
      constructionMaterials: {
        display: true,
        floorType: '',
        floorTypePredicted: null,
        roofType: '',
        roofTypePredicted: null,
        wallType: '',
        wallTypePredicted: null,
        windowType: '',
        windowTypePredicted: null,
        order: 15,
        isEmpty: false,
      },
      utilities: {
        display: true,
        mainsGas: true,
        mainsGasPredicted: null,
        mainsFuelType: '',
        mainsFuelTypePredicted: null,
        hasSolarPower: true,
        hasSolarPowerPredicted: null,
        hasWindTurbines: false,
        hasWindTurbinesPredicted: null,
        waterCompany: null,
        order: 16,
        isEmpty: false,
      },
      propertyRestrictions: {
        isEmpty: false,
        display: true,
        restrictiveCovenants: false,
        nationalPark: false,
        conservationArea: false,
        rightOfWay: null,
        greenBelt: null,
        order: 17,
      },
      coastalErosion: {
        isEmpty: false,
        display: true,
        canHaveErosionPlan: false,
        plans: null,
        order: 18,
      },
      outdoorSpace: {
        display: true,
        outdoorSpaceAreaSquareMetres: null,
        outdoorSpaceAreaAcres: null,
        gardenDirection: null,
        gardenPrimaryOrientation: null,
        preferredUnit: 'acres' as AreaUnit,
        order: 19,
        isEmpty: false,
        outdoorSpacePredicted: null,
      },
      treePreservationOrders: {
        isEmpty: false,
        display: true,
        order: 20,
        content: [],
      },
      titleDeeds: [],
      valuationRequest: {
        display: true,
        order: 1,
      },
      airTrafficNoise: {
        display: true,
        airportNoiseData: null,
        isEmpty: true,
        order: 22,
      },
      parking: {
        display: true,
        hasParking: false,
        isEmpty: false,
        order: 23,
        type: 'ai' as ReportParkingType,
        description: '',
      },
      radonGas: {
        display: true,
        radonRiskLevel: '',
        radonRiskPercentage: '',
        order: 24,
        isEmpty: false,
      },
      order: 1,
    },
    comparables: {
      display: true,
      isEmpty: true,
      sales: {
        display: true, comparables: [], order: 1, isEmpty: true,
      },
      completed: {
        display: true, comparables: [], order: 2, isEmpty: true,
      },
      lettings: {
        display: true, comparables: [], order: 3, isEmpty: true,
      },
      order: 2,
    },
    localArea: {
      display: true,
      transport: {
        display: true,
        bus: null,
        tram: null,
        train: null,
        air: null,
        motorway: null,
        order: 2,
        isEmpty: false,
        nearestAirport: null,
      },
      education: {
        display: true,
        nursery: null,
        primary: null,
        secondary: null,
        post16: null,
        allThrough: null,
        pupilReferralUnits: null,
        special: null,
        independent: null,
        universities: null,
        order: 1,
        isEmpty: false,
      },
      nearbyPlanningApplications: {
        display: true,
        isEmpty: false,
        content: [],
        order: 3,
      },
      nearbyListedBuildings: {
        display: true,
        isEmpty: false,
        content: [],
        order: 4,
      },
      order: 3,
    },
    gallery: {
      display: true,
      isEmpty: false,
      uploadedImages: {
        display: true,
        images: null,
        order: 3,
        isEmpty: false,
      },
      pastListingImages: {
        isEmpty: false,
        pastListingImages: [
          {
            listingId: null,
            display: true,
            date: null,
            images: null,
            order: 1,
            isEmpty: false,
          },
        ],
        display: true,
        order: 2,
      },
      videoAndVirtualTours: {
        display: true,
        videos: [],
        order: 4,
        isEmpty: false,
      },
      streetImages: {
        display: true,
        images: [],
        order: 5,
        isEmpty: false,
      },
      selectedUploadedImages: [],
      order: 4,
    },
    about: {
      display: true,
      agencyBio: {
        display: true,
        heading: '',
        body: '',
        signatureUrl: '',
        signOffTitle: '',
        signOffName: '',
        order: 1,
        isEmpty: false,
      },
      agentBio: {
        display: true,
        heading: '',
        body: '',
        signatureUrl: '',
        signOffTitle: '',
        signOffName: '',
        order: 2,
        isEmpty: false,
      },
      video: {
        display: true,
        source: '',
        order: 3,
        isEmpty: false,
      },
      testimonials: {
        display: true,
        testimonials: [],
        order: 4,
        isEmpty: false,
      },
      contact: {
        display: true,
        order: 5,
      },
      order: 6,
    },
    settings: {
      isEmpty: false,
      recipientIntroduction: '',
      recipients: [],
      reportMessage: '',
      anonymiseAddress: false,
      hideEmptySections: false,
      hideContactDetails: false,
    },
    version: 1,
  },
};
